import { createClient } from '@supabase/supabase-js'

// ⚠️ REMPLACEZ par vos propres credentials Supabase
// Trouvables dans : Settings > API dans votre dashboard Supabase
const SUPABASE_URL = 'https://jczvtbebznqptrvagnum.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_UzLJqJSZ9CtM7euzsRbHhw_mo6rNtEj'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

// Types pour les tables
export interface SignupRow {
  email: string
  url: string
}

export interface EnterpriseLeadRow {
  nom: string
  prenom: string
  email: string
  entreprise: string
  poste: string
  telephone: string
  url: string
}

// Fonctions d'insertion
export async function insertSignup(email: string) {
  const url = typeof window !== 'undefined' ? window.location.href : ''
  const { data, error } = await supabase
    .from('manager_leads')
    .insert([{ email, url }])

  if (error) throw error
  return data
}

export async function insertEnterpriseLead(
  lead: Omit<EnterpriseLeadRow, 'url'>,
) {
  const url = typeof window !== 'undefined' ? window.location.href : ''
  const { data, error } = await supabase
    .from('enterprise_leads')
    .insert([{ ...lead, url }])

  if (error) throw error
  return data
}
